import React from 'react';
import PageHeader from './Header';
import SearchBar from './SearchBar';
import Profile from './Profile';
import MapMain from './MapMain';
import Setting from './Setting';
import HeaderCombine from './HeaderCombine';
import EconomicModelLoginForm from './economicModel/LoginForm';

import { Layout,  Row, Col } from 'antd';
const { Header, Footer, Sider, Content } = Layout;

const EconomicModelPage = () => (
  <Layout>
    <Header>
      <HeaderCombine showProfile={true}/>
    </Header>

    <Content>
        <EconomicModelLoginForm />
    </Content>
  </Layout>

);

export default EconomicModelPage;



// WEBPACK FOOTER //
// ./src/components/EconomicModelPage.js